import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Events } from 'ionic-angular';

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

import { MainPage } from '../main/main';

import { Device } from '@ionic-native/device';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  showBtn: boolean = false;
  deferredPrompt;

  error: string;        // результат выполнения запроса 0-успешно, 1-ошибка
  langs: any;
  timerID: number;
  loadingPopup: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http,
    private device: Device,
    public events: Events
  ) {

    /*console.log('LS id_user: ' + window.localStorage.getItem('id_user'));
    console.log('LS id_lang: ' + window.localStorage.getItem('id_lang'));
    console.log('LS token: ' + window.localStorage.getItem('token'));
    console.log('LS uuid: ' + window.localStorage.getItem('uuid'));

    console.log('Params id_user: ' + this.params.id_user);
    console.log('Params id_lang: ' + this.params.id_lang);
    console.log('Params token: ' + this.params.token);
    console.log('Params uuid: ' + this.params.uuid);*/

    this.loadingPopup = this.loadingCtrl.create({
      content: 'Загрузка'
    });

    this.loadingPopup.present();

    this.GetLangs();

    /*this.Auth();
    
    if (this.params.id_user != null && this.params.id_user != '') {
      //console.log('from_menu: ' + this.navParams.get('from_menu'));
      if (this.navParams.get('from_menu') == '1' || (this.params.id_lang == '' || this.params.id_lang == null)) this.GetLangs();
      else {
        let that = this;
        setTimeout(function () {
          that.navCtrl.setRoot(MainPage);
        }, 5000);
      } 

    }*/

    //console.log(this.params);

  }

  ionViewWillEnter() {
    this.params.stat('home');
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later on the button event.
      this.deferredPrompt = e;

      // Update UI by showing a button to notify the user they can add to home screen
      this.showBtn = true;
    });

    //button click event to show the promt

    window.addEventListener('appinstalled', (event) => {
      //alert('installed');
    });


    if (window.matchMedia('(display-mode: standalone)').matches) {
      //alert('display-mode is standalone');
    }

  }

  add_to_home() {
    this.showBtn = false;
    // hide our user interface that shows our button
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice
      .then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          //alert('User accepted the prompt');
        } else {
          //alert('User dismissed the prompt');
        }
        this.deferredPrompt = null;
      });
  };

  add_to_home_close() {
    this.showBtn = false;
  }

  Exit() {
    window.localStorage.clear();
    this.params.uuid = '';
    this.params.id_user = '';
    this.params.id_lang = '';
    this.params.token = '';
    this.navCtrl.setRoot(HomePage);
  }

  SetLang(id) {
    this.params.id_lang = id;
    window.localStorage.setItem('id_lang', this.params.id_lang);
    
    this.params.menu_sellang = this.params.phrases[this.params.id_lang]['sellang'];
    this.params.menu_reqs = this.params.phrases[this.params.id_lang]['menu-reqs'];
    this.params.menu_info = this.params.phrases[this.params.id_lang]['menu-info'];
    this.params.menu_news = this.params.phrases[this.params.id_lang]['menu-news'];
    this.params.menu_med = this.params.phrases[this.params.id_lang]['menu-med'];
    this.params.menu_urist = this.params.phrases[this.params.id_lang]['menu-urist'];
    this.params.menu_zapis = this.params.phrases[this.params.id_lang]['menu-zapis'];
    this.params.menu_map = this.params.phrases[this.params.id_lang]['menu-map'];
    this.params.menu_about = this.params.phrases[this.params.id_lang]['menu-about'];
    this.params.menu_chlang = this.params.phrases[this.params.id_lang]['menu-lang'];

    this.events.publish('chmenu');

    this.navCtrl.setRoot(MainPage);
  }

  Auth() {
    //Авторизация

    if (window.localStorage.getItem('id_user') == null || window.localStorage.getItem('id_user') == '') {

      this.params.uuid = this.device.uuid;
      //Далее - если вдруг запущено в браузере
      if (this.params.uuid == null) {
        this.params.uuid = 's' + Math.floor(Math.random() * (99999999 - 200)) + 200;
        this.params.runned_in_app = '0';
      }

      this.http.get(this.params.apiURL + '?act=login&uuid=' + this.params.uuid)
        .timeout(20000)
        .map(res => res.json())
        .subscribe(

          data => {
            //console.log(data);
            this.params.id_user = data.id;
            this.params.token = data.token;
            this.error = "0";

            window.localStorage.setItem('uuid', this.params.uuid);
            window.localStorage.setItem('id_user', this.params.id_user);
            window.localStorage.setItem('token', this.params.token);
            window.localStorage.setItem('runned_in_app', this.params.runned_in_app);

            let that = this;
            setTimeout(function(){
              that.savePushRegID();
            }, 4500);

            this.loadingPopup.dismiss();
          },

          err => {
            this.error = "1";
          }

      );

    } else {

      this.params.uuid = window.localStorage.getItem('uuid');
      this.params.id_user = window.localStorage.getItem('id_user');
      this.params.id_lang = window.localStorage.getItem('id_lang');
      this.params.token = window.localStorage.getItem('token');
      this.params.runned_in_app = window.localStorage.getItem('runned_in_app');

      let that = this;
      setTimeout(function () {
        that.savePushRegID();
      }, 4500);
      
      if (this.navParams.get('from_menu') != '1' && this.params.id_lang != 'null'  && this.params.id_lang != null) {
        this.SetLang(this.params.id_lang);
      }

      this.loadingPopup.dismiss();

    }

  }

  savePushRegID() {
    //alert(this.params.apiURL + '?act=save-push-reg-id&id=' + this.params.push_id + '&id_user='+this.params.id_user+'&token='+this.params.token);
    if (this.params.runned_in_app=='1') {
      this.http.get(this.params.apiURL + '?act=save-push-reg-id&id=' + this.params.push_id + '&id_user='+this.params.id_user+'&token='+this.params.token)
        .timeout(20000)
        .map(res => res.json())
        .subscribe(
          data => {
            //console.log(data);
          },

          err => {
            //this.error = "1";
          }

        );
    }
  }  

  GetLangs() {

    /*let loadingPopup = this.loadingCtrl.create({
      content: 'Загрузка..'
    });

    loadingPopup.present();*/

    this.http.get(this.params.apiURL + '?act=langs')
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          console.log('Языки подгружены.');
          this.langs = data;
          this.error = "0";

          //loadingPopup.dismiss();

          this.GetPhrases();

        },

        err => {
          //loadingPopup.dismiss();
          this.error = "1";
        }

      );
  }

  GetPhrases() {

    if (!this.params.phrases) {

      this.http.get(this.params.apiURL + '?act=phrases')
        .timeout(20000)
        .map(res => res.json())
        .subscribe(
          data => {
              console.log('Фразы подгружены.');
              //console.log(data);
              this.params.phrases = data;
              this.error = "0";
              //console.log('Пример:' + this.params.phrases['1']['main-welc']);

              /*this.params.menu_sellang = this.params.phrases[this.params.id_lang]['sellang'];
              this.params.menu_reqs = this.params.phrases[this.params.id_lang]['menu-reqs'];
              this.params.menu_info = this.params.phrases[this.params.id_lang]['menu-info'];
              this.params.menu_news = this.params.phrases[this.params.id_lang]['menu-news'];
              this.params.menu_med = this.params.phrases[this.params.id_lang]['menu-med'];
              this.params.menu_urist = this.params.phrases[this.params.id_lang]['menu-urist'];
              this.params.menu_zapis = this.params.phrases[this.params.id_lang]['menu-zapis'];
              this.params.menu_map = this.params.phrases[this.params.id_lang]['menu-map'];
              this.params.menu_about = this.params.phrases[this.params.id_lang]['menu-about'];
              this.params.menu_chlang = this.params.phrases[this.params.id_lang]['menu-lang'];
  
              this.events.publish('chmenu');*/

              this.Auth();


          },

          err => {
            this.error = "1";
          }

        );

    } else {
      this.Auth();
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts